import React, { Component } from 'react';
import Xheader, { onNavHeightChange } from '@jmfe/jm-xheader';
import elementResizeDetectorMaker from 'element-resize-detector';
import FilterBar from '../../components/Mall/FilterBar';
import PromotionFilterBar from '../../components/Mall/PromotionFilterBar';
import InvestorsRecruitFilterBar from '../../components/Mall/InvestorsRecruitFilterBar';
import MechanismSelectionFilterBar from '../../components/Mall/MechanismSelectionFilterBar';
import AuctionList from '../../components/Mall/AuctionList';
import HeaderAuctionList from '../../components/Mall/HeaderAuctionList';
import Toast from '../../components/common/toast';
import { DEFAULT_ERROR_MSG } from '../../utils/config';
import AuctionPromotionList from '../../components/Mall/AuctionPromotionList';
import InvestorsRecruitList from '../../components/Mall/InvestorsRecruitList';
import MechanismSelectionList from '../../components/Mall/MechanismSelectionList';
import ChuzhiNoticeList from '../../components/Mall/ChuzhiNoticeList';
import BannerSwiper from '../../components/Mall/BannerSwiper';
import { Container, Empty } from './style';
import unit_institution from '../../store/asset_institution/unit_institution';
import unit_institution_promotion from '../../store/asset_institution/unit_institution_promotion';
import unit_institution_mechanismSelection from '../../store/asset_institution/unit_institution_mechanismSelection';
import unit_institution_chuzhi from '../../store/asset_institution/unit_institution_chuzhi';
import TopHeader from '../../components/Mall/TopHeader';
import ZhiboFloor from '../../components/Mall/ZhiboFloor';
import { Tabs } from '@jdcfe/yep-react';
import { isJdapp, callupJDAPP, evokeAppLayerConfig,isIphonex, webviewRedirect, getUrlParms, BUSINESS_INFO,ORG_INFO, AGENCY_INFO, ANNOUNCEMENT_INFO, getApiTypeByGetItem, MpingClick, PVping,      getBusinessTypeByMP, getRealImgPath } from '../../utils/tool';
import { ASSET_TYPE, HOME_PAGE_URL} from '../../utils/enums';

import noDataImg from '../../assets/image/no_data.png';

import AssetInstitutionService from '../../services/AssetInstitutionService';
import InfoService from '../../services/InfoService';

import {getEnv} from '../../utils/tool'

const erd = elementResizeDetectorMaker({
  strategy: 'scroll' 
});

const { TabPanel } = Tabs;
const rootFontSize = parseInt(document.querySelector('html').style.fontSize);

export const ASSET_TYPE_NAME = {
  [ASSET_TYPE.shangYeZiChan]: '商业资产',
  [ASSET_TYPE.jinRongZiChan]: '金融资产',
  [ASSET_TYPE.guoYouZiChan]: '政府国资',
  [ASSET_TYPE.haiGuanFaMo]: '海关缉私',
  [ASSET_TYPE.zhengFuGuoZi]: '政府国资',
}

class UnitInstitution extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseListHasMore: false,
      headerListLength: false,
      fixed: false, // 控制标的筛选条吸顶
      promotionFixed: false, // 控制推介筛选条吸顶
      curTabIndex: 0,
      vendorId: '', // 商家Id
      showTuijieTab: false, // 有推介时才展示推介tab
      navHeight: 0,
      filterOffsetTop: 0, // filterBar距顶部的距离
      liveInfo:'', //直播内容
      isShowContainer: false, //是否展示店铺数据
      isShowTabs: true, //是否展示tab
      zhiBoFloorClientHeight:0, //直播楼层模块高度
      publishSource:'', //业务线参数
      customsStates:0, //区分海关和政府 1:海关 2:政府
      isShowEmpty:false, //是否显示拖底页面
      bannerList: [], // 轮播图数据
      orgType: null, // 11-海关，12-政府 19-国资
      assetType: null, // 8-商业资产 7-金融资产 10-国有资产 11-海关罚没 12-政府国资
      showChuZhiNoticeTab: false // 是否展示处置公告的tab
    };
    
    this.zhiBoFloorRef = ref=>{this.refDom=ref}

    // 保存店铺Id
    const vendorId = this.props.match.params.vendorId
    unit_institution.vendorId = vendorId;
  }

  componentDidMount() {
    MpingClick("MAuction_PublicAuctionList")
    this.getPublishSource()
    const vendorId = this.props.match.params.vendorId
    this.setState({
      vendorId
    })
    this.setTransHeader()
    this.listenTopHeaderHeight()
    callupJDAPP()
    evokeAppLayerConfig(encodeURIComponent(window.location.href));
    this.getLiveInfoByVendorId()

    this.renderItemTabContent = this.renderItemTabContent.bind(this);
    this.renderPromotionContent = this.renderPromotionContent.bind(this);
    this.renderChuzhiNoticeContent = this.renderChuzhiNoticeContent.bind(this);

    // if (getEnv() === 'jdapp' && typeof document.addEventListener !== "undefined") {
    //   document.addEventListener('visibilitychange',()=>{
    //     if(document.visibilityState!=='hidden') {
    //       unit_institution.resetAuctionList()
    //       unit_institution_promotion.resetAuctionList()
    //       unit_institution_mechanismSelection.resetAuctionList()
    //       this.getPublishSource()
    //     }
    //   });
    // }
  }

  componentWillUnmount() {
    const topHeaderContainer = document.getElementById('topHeader')
    if (topHeaderContainer) {
      erd.removeAllListeners(topHeaderContainer)
    }
  }

  getBannerList(vendorId, publishSource, idType) {
    if (!vendorId || !publishSource) return;
    let areaId = null;
    const info = idType === 2 ? ORG_INFO : BUSINESS_INFO
    Object.keys(info).forEach(key => {
      if (info[key].code === publishSource && info[key].adAreaId) {
        areaId = info[key].adAreaId;
      }
    })
    if (!areaId) return;
    const params = {
      id: vendorId,
      areaId
    }

    InfoService.getAdData(params).then(res => {
      if (res && res.statusCode === 200 && res.data && res.data.length > 0) {
        const data = res.data.filter(item => !!item.imageUrl).map((item) => {
          return {
            imgUrl: getRealImgPath({url: item.imageUrl, size: '750x140'}),
            linkUrl: item.url,
            content: item.content
          }
        })
        this.setState({
          bannerList: data
        })
      }
    })
  }

  getPublishSource=()=>{
    this.pageInitByShopApi()
  }

  /**
   * 通过接口获取publishSource后，进行页面渲染
   */
  pageInitByShopApi=()=>{
    /** *
      因为有部分店铺没有在音速维护，所以无法判断店铺所属业务线和类型，需要地址栏透传这两个参数(publishSource、idType)进行拖底
    */
    const publishSourceByUrl = getUrlParms("publishSource") || ""
    const idType = getUrlParms("orgIdType") || ""
    const vendorId = this.props.match.params.vendorId
    unit_institution_promotion.vendorId = vendorId;

    InfoService.getShopOrganizationInfo(vendorId,publishSourceByUrl,idType,false).then(res=>{
      const {
        publishSource,
        idType,
        orgType,
        assetType
      } = res.data
      if(publishSource && idType){
        this.setState({
          isShowEmpty: false,
          orgType: orgType && orgType[0],
          assetType
        },()=>{
          this.pageInit(publishSource, idType)
        })
      }else{
        this.setState({
          isShowEmpty: true
        })
        const scan = getUrlParms("scan")
        if(scan){
          MpingClick("Auction_NewShop",JSON.stringify({business_type:getBusinessTypeByMP(),from_type:1}))
        }else{
          MpingClick("Auction_NewShop",JSON.stringify({business_type:getBusinessTypeByMP(),from_type:0}))
        }
      }
      const scan = getUrlParms('scan')
      PVping('MAuction_NewShop', {
        'action_source': '' + publishSource,
        'from_type': scan ? '1' : '0'
      })
    }).catch(()=>{
      // Toast.fail({
      //   message: DEFAULT_ERROR_MSG,
      //   duration: 2500
      // })
      this.setState({
        isShowEmpty: true
      })
      const scan = getUrlParms("scan")
      if(scan){
        MpingClick("Auction_NewShop",JSON.stringify({business_type:getBusinessTypeByMP(),from_type:1}))
      }else{
        MpingClick("Auction_NewShop",JSON.stringify({business_type:getBusinessTypeByMP(),from_type:0}))
      }
    })
  }

  /**
   * 获取publishSource后页面初始加载数据
  */
  pageInit=(publishSource, idType)=>{
    this.setState({
      publishSource: parseInt(publishSource)
    },()=>{
      const { getAuctionList, getCollapseHeaderAuctionList } = unit_institution; // 拍品
      const { getPromotionAuctionList } = unit_institution_promotion; // 推介
      const { getMechanismSelectionList } = unit_institution_mechanismSelection; // 机构选聘
      const { getChuzhiNoticeList } = unit_institution_chuzhi; // 处置公告

      // 从页面路径上获取相关参数
      const vendorId = this.props.match.params.vendorId
      // 原需要再店铺页隐藏的拍卖ID，现在不需要隐藏了，故传空
      const excludeCollapsePaimaiId = getUrlParms("excludeCollapsePaimaiId")

      const topPaimaiIds = getUrlParms("topPaimaiIds")
      const topTuijieIds = getUrlParms("topTuijieIds")

      // 获取店铺广告位数据
      this.getBannerList(vendorId, publishSource, idType);

      // 埋点上报（scan来自PC店铺页的二维码，scan=1）
      const scan = getUrlParms("scan")
      if(scan){
        MpingClick("Auction_NewShop",JSON.stringify({business_type:getBusinessTypeByMP(),from_type:1}))
      }else{
        MpingClick("Auction_NewShop",JSON.stringify({business_type:getBusinessTypeByMP(),from_type:0}))
      }

      // 查询拍品数据
      unit_institution.publishSource = publishSource;
      unit_institution.apiType = getApiTypeByGetItem(publishSource);
      if(publishSource==BUSINESS_INFO.HAIGUANANDZF.code){
        unit_institution.idType = idType
      }
      if (excludeCollapsePaimaiId || topPaimaiIds) {
        // 查询折叠拍品列表（折叠拍品是单独查询接口，不在大搜接口里）
        if (excludeCollapsePaimaiId) {
          unit_institution.collapseSrcPaimaiId = excludeCollapsePaimaiId;
          getCollapseHeaderAuctionList({ collapseSrcPaimaiId: excludeCollapsePaimaiId }, 0).then(res => {
            if (res && res.datas && res.datas.length) {
              this.setState({
                headerListLength: true
              })
            } else {
              this.setState({
                headerListLength: false
              })
            }
            if (res && res.totalItem > 30) {
              this.setState({
                collapseListHasMore: true,
              })
            }
          })
        }
        // 增加折叠拍品和置顶拍品参数
        unit_institution.condition = {
          ...unit_institution.condition,
          collapseSrcPaimaiId: excludeCollapsePaimaiId || '',
          topIdList: topPaimaiIds || ''
        }
      }
      getAuctionList();

      // 查询推介数据
      if(publishSource==BUSINESS_INFO.ZICHAN.code || publishSource==BUSINESS_INFO.POCHAN.code || publishSource==BUSINESS_INFO.HAIGUANANDZF.code){
        if(publishSource==BUSINESS_INFO.ZICHAN.code){
          unit_institution_promotion.auctionType = 4
          unit_institution_promotion.shopDisplay = 1
        } else if (publishSource==BUSINESS_INFO.HAIGUANANDZF.code) {
          unit_institution_promotion.auctionType = 2
          unit_institution_promotion.belongOrgDisplay = 1
          unit_institution_promotion.publishSource = publishSource
        } else{
          unit_institution_promotion.auctionType = 5
        }
        unit_institution_promotion.vendorId = vendorId;
        unit_institution_promotion.idType = idType;
        unit_institution_promotion.topIdList = topTuijieIds || '';
        getPromotionAuctionList();
      }

      // 查询机构选聘数据
      if(publishSource==BUSINESS_INFO.POCHAN.code){
        unit_institution_mechanismSelection.vendorId = vendorId;
        getMechanismSelectionList();
      }
      // 查询处置公告
      if (publishSource === BUSINESS_INFO.ZICHAN.code) {
        unit_institution_chuzhi.vendorId = vendorId;
        getChuzhiNoticeList();
      }

      // 资产和破产、海关政府条线底部有Tab，需要设置tab选中状态（只默认选中拍品和推介）
      if (publishSource==BUSINESS_INFO.ZICHAN.code || publishSource==BUSINESS_INFO.POCHAN.code || publishSource==BUSINESS_INFO.HAIGUANANDZF.code) {
        this.setCurTabIndex();
      }
    })
  }

  getAuctionTypeByGetTuijie=(publishSource)=>{
    let auctionType = 4
    if(publishSource==BUSINESS_INFO.POCHAN.code){
      auctionType = 5
    }
    return auctionType
  }

  //进入店铺时资产、破产业务线底部Tab默认显示规则
  setCurTabIndex=()=>{
    let curTabIndex = 1
    // 注意：这里的查询仅用于判断拍品和推介是否有数据，不做展示用，不能使用store里的方法，否则会影响store中的数据项
    // 查询时筛选条件需要使用store中的部分参数，不然筛选条件不同步（只查第一页的第一条数据）

    // 仅查询是否有预告中和进行中的拍品
    const auctionParams = unit_institution.getSellectionParams();
    auctionParams.page = 1;
    auctionParams.pageSize = 1;
    auctionParams.multiPaimaiStatus = '0,1'; //预告+进行中

    // 查询在店铺页展示的推介数（有些推介设置了不在店铺页展示）
    const promotionParams = unit_institution_promotion.getSelectionParams();
    promotionParams.page = 1;
    promotionParams.pageSize = 1;
    if(unit_institution.publishSource==BUSINESS_INFO.ZICHAN.code){
      promotionParams.shopDisplay=1 // 是否在店铺页展示
    }

    if(unit_institution.publishSource==BUSINESS_INFO.HAIGUANANDZF.code) {
      promotionParams.belongOrgDisplay = 1 // 政府海关品类是否在店铺页展示
    }
    Promise.all([
      AssetInstitutionService.getTargetAuctionList(auctionParams),
      AssetInstitutionService.getPromotionAuctionList(promotionParams),
    ]).then(res=>{
      if(res && res.length===2){
        const auctionListNotEndList = res[0] //预告中+进行中的拍品
        const promotionAuctionList = res[1] && res[1].data //推介
        const auctionListNotEndListTotalItem = auctionListNotEndList && auctionListNotEndList.totalItem
        const promotionAuctionListTotalItem = promotionAuctionList && promotionAuctionList.totalCount
        if (getUrlParms('announcement') && getUrlParms('announcement') == ANNOUNCEMENT_INFO.YES.code) {
          curTabIndex=2
        }else if (getUrlParms('agency') && getUrlParms('agency') == AGENCY_INFO.YES.code) {
          curTabIndex=3
        } else {
          if(auctionListNotEndListTotalItem>0){
            curTabIndex=1
          }else {
            const isProductFirst = getUrlParms("isProductFirst") || 'true'; // 店铺卡片跳转时携带的参数，表示是否优先展示拍品Tab
            // 1. 推介有数据且url上isProductFirst为false时，展示推介Tab
            // 2. 推介有数据，但拍品没数据，展示推介Tab
            if(promotionAuctionListTotalItem > 0 && (isProductFirst === 'false' || auctionListNotEndListTotalItem <= 0 )){
              curTabIndex=2
            }else{
              curTabIndex=1
            }
          }
        }

        this.setState({
          curTabIndex,
        },()=>{
          unit_institution.curTabIndex = this.state.curTabIndex;
        })
      }
    }).catch(err => {
      // 接口请求失败时，默认展示当前tab
      this.setState({
        curTabIndex,
      },()=>{
        unit_institution.curTabIndex = this.state.curTabIndex;
      })
    }).finally(()=>{
      this.setState({
        isShowContainer:false
      },()=>{
        this.setState({
          isShowContainer:true
        })
      })
    })
  }

  /**
   * 监听topHeader高度变化
   */
    listenTopHeaderHeight() {
    const topHeaderContainer = document.getElementById('topHeader')
    if (topHeaderContainer) {
      erd.listenTo(topHeaderContainer, (element) => {
        this.setState({
          filterOffsetTop: element.offsetHeight + unit_institution.zhiBoFloorClientHeight
        })
      })
    }
  }

  shouldShowFilterBlock = () => {
    const { fixed } = this.state;
    if (fixed) {
      return (<div className={`filter-block ${getEnv() === 'jdapp'?'jdapp-filter-block':''}`}></div>)
    }

    if (!fixed) {
      return null;
    }
  };

  shouldShowFilterBlockPromotion = () => {
    const { promotionFixed } = this.state;
    if (promotionFixed) {
      return (<div className={`filter-block ${getEnv() === 'jdapp'?'jdapp-filter-block':''}`}></div>)
    }

    if (!promotionFixed) {
      return null;
    }
  };

  onChangeTabs = (index) => {
    const { publishSource } = this.state;
    let url = '//mauction.jd.com/home.html'
    if(publishSource==BUSINESS_INFO.ZICHAN.code){
      url = '//mauction.jd.com/assets/home.html'
    }else if(publishSource==BUSINESS_INFO.POCHAN.code){
      url = '//mauction.jd.com/channel/home.html#/bankruptcy'
    }
    if(index===0){
      // if(publishSource==BUSINESS_INFO.ZICHAN.code){
      //   MpingClick("Auction_AssetConduct",JSON.stringify({business_type:getBusinessTypeByMP()}))
      // }else if(publishSource==BUSINESS_INFO.POCHAN.code){
      //   MpingClick("Auction_BrokeClear",JSON.stringify({business_type:getBusinessTypeByMP()}))
      // }
      // setTimeout(()=>{
      //   webviewRedirect(url)
      // })
    }else{
      const { changeTab } = unit_institution;
      changeTab(index);
      if(index===1){
        MpingClick("Auction_ObjectList",JSON.stringify({business_type:getBusinessTypeByMP()}))
      }else if(index===2){
        if(publishSource==BUSINESS_INFO.ZICHAN.code){
          MpingClick("Auction_AssetRecomm",JSON.stringify({business_type:getBusinessTypeByMP()}))
        }else if(publishSource==BUSINESS_INFO.POCHAN.code){
          MpingClick("Auction_InvestorRecruit",JSON.stringify({business_type:getBusinessTypeByMP()}))
        }
      }else if(index===3){
        MpingClick("Auction_InstitutionChoose",JSON.stringify({business_type:getBusinessTypeByMP()}))
      }
      this.setState({
        curTabIndex: index,
      },()=>{
        unit_institution.curTabIndex = this.state.curTabIndex;
      })
      if(window && window.scrollTo){
        window.scrollTo(0,0);
      }
    }
  }

  setTransHeader() {
    if (isJdapp()) {
      Xheader({
        supportTran: '1',
      }).then(height => {
        this.setState({
          navHeight: height
        })
      })
    }
  }

  //标的物
  renderItemTabContent(isLoadNext) {
    const { navHeight, collapseListHasMore, headerListLength } = this.state;
    const adaptationTop = this.getAdaptationTop()
    return (
      <Container>
        <div className="filter-bar">
          <FilterBar
            sticky={true}
            navHeight={navHeight}
            store={unit_institution}
            changeBlockStatus={fixed => this.setState({ fixed })
            }
            adaptationTop={adaptationTop}
          ></FilterBar>
          {this.shouldShowFilterBlock()}
        </div>
        {headerListLength && <HeaderAuctionList collapseListHasMore={collapseListHasMore} isLoadNext={isLoadNext} store={unit_institution}></HeaderAuctionList>}
        <AuctionList isLoadNext={isLoadNext} store={unit_institution}></AuctionList>
      </Container>
    )
  }

  // 海关-推介、资产-推介
  renderPromotionContent(isLoadNext) {
    const { navHeight } = this.state;
    const adaptationTop = this.getAdaptationTop()
    return (
      <Container>
        <div className="filter-bar">
          <PromotionFilterBar
            sticky={true}
            navHeight={navHeight}
            store={unit_institution_promotion}
            changeBlockStatus={promotionFixed => this.setState({ promotionFixed })
            }
            adaptationTop={adaptationTop}
          ></PromotionFilterBar>
          {this.shouldShowFilterBlockPromotion()}
        </div>
        <AuctionPromotionList isLoadNext={isLoadNext} store={unit_institution_promotion}></AuctionPromotionList>
      </Container>
    )
  }

  // 处置公告
  renderChuzhiNoticeContent(isLoadNext) {
    return (
      <Container>
        <ChuzhiNoticeList isLoadNext={isLoadNext} store={unit_institution_chuzhi}></ChuzhiNoticeList>
      </Container>
    )
  }

  //破产-投资人招募
  renderInvestorsRecruitContent(isLoadNext) {
    const { navHeight } = this.state;
    const adaptationTop = this.getAdaptationTop()
    return (
      <Container>
        <div className="filter-bar">
          <InvestorsRecruitFilterBar
            sticky={true}
            navHeight={navHeight}
            store={unit_institution_promotion}
            changeBlockStatus={promotionFixed => this.setState({ promotionFixed })
            }
            adaptationTop={adaptationTop}
          ></InvestorsRecruitFilterBar>
          {this.shouldShowFilterBlockPromotion()}
        </div>
        <InvestorsRecruitList isLoadNext={isLoadNext} store={unit_institution_promotion}></InvestorsRecruitList>
      </Container>
    )
  }

  //破产-机构选聘
  renderMechanismSelectionContent(isLoadNext) {
    const { navHeight } = this.state;
    const adaptationTop = this.getAdaptationTop()
    return (
      <Container>
        <div className="filter-bar">
          <MechanismSelectionFilterBar
            sticky={true}
            navHeight={navHeight}
            store={unit_institution_mechanismSelection}
            changeBlockStatus={promotionFixed => this.setState({ promotionFixed })
            }
            adaptationTop={adaptationTop}
          ></MechanismSelectionFilterBar>
          {this.shouldShowFilterBlockPromotion()}
        </div>
        <MechanismSelectionList isLoadNext={isLoadNext} store={unit_institution_mechanismSelection}></MechanismSelectionList>
      </Container>
    )
  }

  getAdaptationTop() {
    const {
      filterOffsetTop
    } = this.state
    return filterOffsetTop + (document.getElementById('m_common_tip') ? document.getElementById('m_common_tip').clientHeight : 0)
  }

  getLiveInfoByVendorId(){
    const idType = getUrlParms("orgIdType") || ""
    if (idType == 2) {
      console.log('机构直播不展示直播楼层') // 机构直播不展示直播楼层
      return;
    }
    const vendorId = this.props.match.params.vendorId
    AssetInstitutionService.getLiveInfoByVendorId({vendorId:vendorId}).then(res=>{ 
      if(res && res.data && JSON.stringify(res.data)!=="{}"){
        this.setState({
          liveInfo: res.data
        },()=>{
          if(this.refDom){
            const {clientHeight} = this.refDom
            unit_institution.zhiBoFloorClientHeight=clientHeight
          }
        })
      }
    })
  }

  renderZiChan=()=>{
    const { curTabIndex,isShowTabs, publishSource, showChuZhiNoticeTab, assetType } = this.state;
    const lableText = ASSET_TYPE_NAME[assetType] || '资产处置'
    const tabPanelConfigs = [{
      tabName: '标的物',
      tabClass: 'zichanbdw',
      render: this.renderItemTabContent
    }, {
      tabName: publishSource === BUSINESS_INFO.HAIGUANANDZF.code ? '推介': '资产推介',
      tabClass: 'zctj',
      render: this.renderPromotionContent
    }]
    // 处置公告有数据才展示
    if (showChuZhiNoticeTab) {
      tabPanelConfigs.push({
        tabName: '处置公告',
        tabClass: 'czgg',
        render: this.renderChuzhiNoticeContent
      })
    }
    return (
      <React.Fragment>
        {isShowTabs &&
          <>
            <div className={`tab-wrap ${isIphonex()?'iphonex':''}`} onClick={()=>{
              if (publishSource === BUSINESS_INFO.ZICHAN.code) {
                MpingClick("Auction_AssetConduct",JSON.stringify({business_type:getBusinessTypeByMP()}))
              }
              switch (assetType) {
                case ASSET_TYPE.shangYeZiChan:
                  webviewRedirect(HOME_PAGE_URL.shangYeZiChan)
                  break;
                case ASSET_TYPE.jinRongZiChan:
                  webviewRedirect(HOME_PAGE_URL.jinRongZiChan)
                  break;
                case ASSET_TYPE.guoYouZiChan:
                  webviewRedirect(HOME_PAGE_URL.guoYouZiChan)
                  break;
                case ASSET_TYPE.haiGuanFaMo:
                  webviewRedirect(HOME_PAGE_URL.haiGuanFaMo)
                  break;
                case ASSET_TYPE.zhengFuGuoZi:
                  webviewRedirect(HOME_PAGE_URL.zhengFuGuoZi)
                  break;
                default:
                  webviewRedirect(HOME_PAGE_URL.paimaiHome)
                  break;
              }


              // if (publishSource === BUSINESS_INFO.HAIGUANANDZF.code) {
              //   if (orgType === 11) {
              //     // 海关缉私
              //     webviewRedirect('//pmthr.m.jd.com/dynamic?&appletsCode=new_customs_search_home&jdreactapp=JDReactPaimaiIndexThree&pageParam=new_customs_search_home&page=dynamic&transparentenable=true&jdreactkey=JDReactPaimaiIndexThree')
              //   } else {
              //     // 政府国资
              //     webviewRedirect('//pmsec.m.jd.com/paimaiGovernment?jdreactapp=JDReactPaimaiIndexSecond&rn_page=paimaiGovernment&jdreactAppendPath=paimaiGovernment&jdreactkey=JDReactPaimaiIndexSecond')
              //   }
              // } else {
              //   if (orgType === 8) {
              //     // 商业资产
              //     webviewRedirect('//pmthr.m.jd.com/dynamic?page=dynamic&appletsCode=commercial_assets_search_home&pageParam=commercial_assets_search_home&transparentenable=true&jdreactkey=JDReactPaimaiIndexThree&jdreactapp=JDReactPaimaiIndexThree')
              //   } else {
              //     // 金融资产
              //     webviewRedirect('//pmthr.m.jd.com/dynamic?page=dynamic&appletsCode=assets_search_home&transparentenable=true&jdreactkey=JDReactPaimaiIndexThree&jdreactapp=&&defaultLabels=1033&pageParam=assets_search_home')
              //   }
              // }
            }}>
              <div className="tab-icon zccz"></div>
              <div className="tab-txt index-txt">
                { lableText }
              </div>
            </div>
            <Tabs animated={false}
              onChange={(index) => this.onChangeTabs(index)}
              swipeable={false}
              defaultIndex={curTabIndex}
              tabBarUnderlineStyle={{display:'none'}}
              className={isIphonex()?'iphonex':''}
              ref={node => (this.tabs = node)}
            >
              <div></div>
              {
                tabPanelConfigs.map((tab,index) => {
                  return (
                    <TabPanel tab={<div className="tab-wrap">
                      <div className={`tab-icon ${tab.tabClass}`}></div>
                      <div className="tab-txt">{tab.tabName}</div>
                      </div>}
                    >
                      {tab.render && tab.render()}
                    </TabPanel>
                  )
                })
              }
            </Tabs>
          </>
        }
      </React.Fragment>
    )
  }

  renderPoChan=()=>{
    const { curTabIndex,isShowTabs } = this.state;
    return (
      <React.Fragment>
        {isShowTabs &&
        <>
          <div className={`tab-wrap ${isIphonex()?'iphonex':''}`} style={{width:'25%'}} onClick={()=>{
              MpingClick("Auction_BrokeClear",JSON.stringify({business_type:getBusinessTypeByMP()}))
              webviewRedirect("//pro.m.jd.com/mall/active/3PYezEmTzyFzutrbBXHA2GAE64Hr/index.html?mTabId=244pVabo1RL3DZeDTJKG3tdHwfKp")
            }}>
            <div className="tab-icon pcqq"></div>
            <div className="tab-txt index-txt">重整与清算</div>
          </div>
          <Tabs animated={false}
            onChange={(index) => this.onChangeTabs(index)}
            swipeable={false}
            defaultIndex={curTabIndex}
            tabBarUnderlineStyle={{display:'none'}}
            className={isIphonex()?'iphonex':''}
          >
            <div></div>
            <TabPanel tab={<div className="tab-wrap">
              <div className="tab-icon pochanbdw"></div>
              <div className="tab-txt">标的物</div>
              </div>}
            >
              {this.renderItemTabContent()}
            </TabPanel>
            <TabPanel tab={<div className="tab-wrap">
                <div className="tab-icon tzrzm"></div>
                <div className="tab-txt">投资人招募</div>
              </div>}
            >
              {this.renderInvestorsRecruitContent()}
            </TabPanel>
            <TabPanel tab={<div className="tab-wrap">
                <div className="tab-icon jgxp"></div>
                <div className="tab-txt">机构选聘</div>
              </div>}
            >
              {this.renderMechanismSelectionContent()}
            </TabPanel>
          </Tabs>
        </>
        }
      </React.Fragment>
    )
  }

  renderSiFa=()=>{
    return (
      <React.Fragment>
        {this.renderItemTabContent()}
      </React.Fragment>
    )
  }

  render() {
    const { vendorId, navHeight, liveInfo,isShowContainer, publishSource, isShowEmpty, bannerList } = this.state;
    return (
      <Container>
        <div id="topHeader">
          {vendorId && <TopHeader
            vendorId={vendorId}
            navHeight={navHeight}
            showTuijieTab={() => {
              this.setState({
                showTuijieTab: true
              })
            }}
            showChuZhiNoticeTab={() => {
              this.setState({
                showChuZhiNoticeTab: true
              })
            }}
            publishSource={publishSource}
          />}
        </div>
        {liveInfo && <div ref={this.zhiBoFloorRef}><ZhiboFloor liveInfo={liveInfo}></ZhiboFloor></div>}
        {!!bannerList.length && <BannerSwiper bannerList={bannerList} vendorId={vendorId} publishSource={publishSource}/>}
        {publishSource==BUSINESS_INFO.ZICHAN.code && isShowContainer && this.renderZiChan()}
        {publishSource==BUSINESS_INFO.POCHAN.code && isShowContainer &&  this.renderPoChan()}
        {publishSource==BUSINESS_INFO.HAIGUANANDZF.code && isShowContainer && this.renderZiChan()}
        {publishSource==BUSINESS_INFO.SIFA.code && this.renderSiFa()}
        {isShowEmpty===true &&      
          <Empty>
            <img src={noDataImg} alt=""/>
            <p>暂无符合条件的标的，去看看其他标的吧~</p>
          </Empty>
        }
      </Container>
    );
  }
}

export default UnitInstitution;
